"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var defaultProps = {
    size: 'medium',
    variant: 'primary'
};
// eslint-disable-next-line no-redeclare
var Link = function (_a) {
    var _b = _a.size, size = _b === void 0 ? defaultProps.size : _b, _c = _a.variant, variant = _c === void 0 ? defaultProps.variant : _c, children = _a.children, className = _a.className, href = _a.href, anchorHtmlProps = __rest(_a, ["size", "variant", "children", "className", "href"]);
    // mortar-core typography sizes are not defined relative to Body/Title/Label/Utility, so their respective sizes have to be mapped to mortar-core sizes
    var sizeMap = {
        xxlarge: 'xlarge',
        xlarge: 'large',
        large: 'medium',
        medium: 'small',
        small: 'xsmall'
    };
    var cls = (0, classnames_1.default)("pg--fontFamily-serif", "pg--weight-normal", "pg--link", "pg--size-".concat(sizeMap[size]), "pg--variant-".concat(variant), className);
    return (react_1.default.createElement("a", __assign({ className: cls, href: href }, anchorHtmlProps), children));
};
Link.defaultProps = defaultProps;
exports.default = Link;
